module.exports = __webpack_public_path__ + "img/BAU Seniors_Infographics_31.69bc05ea.png";